"use client";

import { RotateCcwIcon } from "lucide-react";
import Link from "next/link";

import { Button } from "@/shared-web.ui/ui.button";

interface ServerErrorProps {
  error: { digest?: string } & Error;
  reset?: () => void;
  resetLabel?: string;
}
const ServerError = (props: ServerErrorProps) => {
  const { error, reset, resetLabel } = props;

  return (
    <div className={`
      flex h-dvh items-center justify-center bg-gray-1
    `}
    >
      <div className="max-w-screen-md p-6">
        <h1 className={`
          mb-4 text-8 text-gray-11
          sm:text-9
        `}
        >
          <span className="font-bold text-accent-11">Oops!</span>
          {" "}
          Something Went Wrong.
        </h1>
        <p className="mb-6 text-gray-11">
          We’re sorry, but something went wrong with your request. It could be a temporary issue, or the page might be unavailable.
        </p>
        <p className="mb-4 text-gray-11">
          Error Code:
          {" "}
          <span className="font-semibold">
            { error.digest || "500"}
          </span>
        </p>
        <div className={`
          mt-10 flex flex-col items-start justify-start
          gap-8
          sm:flex-row sm:items-center
        `}
        >
          <Link href="/">
            <Button size="4">
              Go to Homepage
            </Button>
          </Link>
          {reset && (
            <Button
              onClick={reset}
              size="4"
              variant="outline"
            >
              <RotateCcwIcon
                strokeWidth="2"
                className="size-5"
              />
              {resetLabel || "Try Again"}
            </Button>
          )}
        </div>
      </div>
    </div>
  ); ;
};

export { ServerError };
